<template>
  <b-modal
    id="modal-adicionar-microarea"
    ref="modalAdicionarMicroArea"
    :title="modalMode === 'edit' ? 'Editar microárea' : 'Adicionar microárea'"
    centered
    hide-footer
    @hidden="onHidden"
  >
    <ValidationObserver ref="form">
      <b-alert
        v-if="modalAlert.show"
        :variant="modalAlert.variant"
        show
        class="mb-3"
      >
        {{ modalAlert.message }}
      </b-alert>

      <div v-if="modalLoading" class="modal-loading">
        <div class="text-center">
          <b-spinner label="Carregando" />
        </div>
      </div>

      <b-form v-else @submit.prevent="onSubmit">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="form-group">
            <label for="ubs">UBS</label>
            <vue-select
              class="select-ubs"
              :options="ubsOptions"
              label="no_unidade_saude"
              placeholder=""
              v-model="formLocal.ubs"
              :loading="loadingSelectEstabelecimento"
              :disabled="loadingSelectEstabelecimento"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_unidade_saude }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
            <div v-if="ubsInvalidaNaEdicao" class="error">
              Esse estabelecimento de saúde não contém a equipe selecionada.
            </div>
          </div>
        </validation-provider>

        <validation-provider v-slot="{ errors }" rules="required">
          <div class="form-group">
            <label>Equipe</label>
            <vue-select
              class="select-equipes"
              :options="equipesOptions"
              label="no_esf_eap"
              placeholder=""
              v-model="formLocal.equipe"
              :clearable="false"
              :disabled="modalMode === 'edit' || !formLocal.ubs"
              :readonly="modalMode === 'edit' || !formLocal.ubs"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_esf_eap }} - {{ option.ine_esf_eap }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>

            <div class="error">{{ errors[0] }}</div>
            <div v-if="ineInvalido" class="error">
              O INE dessa equipe não pertence a esse estabelecimento de saúde.
              Selecione a equipe correta!
            </div>
          </div>
        </validation-provider>

        <validation-provider
          v-slot="{ errors }"
          rules="required|max:2|onlyNumbers"
        >
          <div class="form-group">
            <label for="microarea">Microárea</label>
            <input
              id="microarea"
              type="text"
              class="form-control"
              v-model.trim="formLocal.microarea"
              v-inputmask="maskMicroarea"
              placeholder="Ex: 01"
              :disabled="modalMode === 'edit'"
              :readonly="modalMode === 'edit'"
            />
            <div class="error">{{ errors[0] }}</div>
          </div>
        </validation-provider>

        <validation-provider v-slot="{ errors }" rules="required">
          <div class="form-group">
            <label for="localidade">Localidade</label>
            <vue-select
              class="select-localidade"
              :options="localidadeOptions"
              label="label"
              placeholder=""
              v-model="formLocal.localidade"
              :clearable="false"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
            <div class="error">{{ errors[0] }}</div>
          </div>
        </validation-provider>

        <validation-provider
          v-slot="{ errors }"
          rules="required|maxValue:750|onlyNumbers"
        >
          <div class="form-group">
            <label for="quantidadePessoas">Quantidade de pessoas</label>
            <input
              id="quantidadePessoas"
              type="text"
              class="form-control"
              v-model.trim="formLocal.quantidadePessoas"
              v-inputmask="maskQuantidadePessoas"
              placeholder="Ex: 750"
            />
            <div class="error">{{ errors[0] }}</div>
          </div>
        </validation-provider>

        <validation-provider v-slot="{ errors }" rules="">
          <div class="form-group">
            <label for="observacoes">Observações</label>
            <textarea
              id="observacoes"
              class="form-control"
              v-model.trim="formLocal.observacoes"
              rows="4"
              placeholder=""
            ></textarea>
            <div class="error">{{ errors[0] }}</div>
          </div>
        </validation-provider>

        <div class="d-flex justify-content-between">
          <div>
            <b-button
              v-if="modalMode === 'edit' && formLocal.ativo === 1"
              class="btn-inativar"
              @click="onInativar"
              :disabled="saving"
            >
              <i
                v-if="loadingAction !== 'inativar'"
                class="icofont-power mr-1"
              ></i>

              <span v-if="loadingAction === 'inativar'">
                Inativando...
                <b-spinner small class="ml-2" />
              </span>
              <span v-else>Inativar</span>
            </b-button>

            <b-button
              v-if="modalMode === 'edit' && formLocal.ativo === 0"
              class="btn-reativar"
              @click="onReativar"
              :disabled="saving"
            >
              <i
                v-if="loadingAction !== 'reativar'"
                class="icofont-refresh mr-1"
              ></i>

              <span v-if="loadingAction === 'reativar'">
                Reativando...
                <b-spinner small class="ml-2" />
              </span>
              <span v-else>Reativar</span>
            </b-button>
          </div>

          <div>
            <!-- <b-button class="mr-2 btn-cancelar" @click="fechar">
              Cancelar
            </b-button> -->

            <b-button variant="primary" type="submit" :disabled="saving">
              <span v-if="loadingAction === 'salvar'">
                {{ modalMode === 'create' ? 'Adicionando...' : 'Salvando...' }}
                <b-spinner small class="ml-2" />
              </span>

              <span v-else>
                {{ modalMode === 'create' ? 'Adicionar' : 'Salvar' }}
              </span>
            </b-button>
          </div>
        </div>
      </b-form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
import Masks from '@/mixins/masks'

validations()

export default {
  name: 'ModalMicroArea',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    modalMode: {
      type: String,
      default: 'create',
    },
    modalLoading: {
      type: Boolean,
      default: false,
    },
    loadingSelectEstabelecimento: {
      type: Boolean,
      default: false,
    },
    ubsOptions: {
      type: Array,
      default: () => [],
    },
    equipesOptions: {
      type: Array,
      default: () => [],
    },
    localidadeOptions: {
      type: Array,
      default: () => [],
    },
    form: {
      type: Object,
      default: () => ({
        ubs: null,
        equipe: null,
        microarea: null,
        localidade: null,
        quantidadePessoas: null,
        observacoes: null,
        ativo: 1,
      }),
    },
  },
  data() {
    return {
      saving: false,
      loadingAction: null,
      modalAlert: {
        show: false,
        variant: 'success',
        message: '',
      },
      formLocal: {
        ubs: null,
        equipe: null,
        microarea: null,
        localidade: null,
        quantidadePessoas: null,
        observacoes: null,
        ativo: 1,
      },
      ineInvalido: false,
      ubsInvalidaNaEdicao: false,
    }
  },
  computed: {
    maskMicroarea() {
      return Masks['microarea']
    },
    maskQuantidadePessoas() {
      return Masks.numberDynamic(3)
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.formLocal = {
          ubs: value?.ubs ?? null,
          equipe: value?.equipe ?? null,
          microarea: value?.microarea ?? null,
          localidade: value?.localidade ?? null,
          quantidadePessoas: value?.quantidadePessoas ?? null,
          observacoes: value?.observacoes ?? null,
          ativo: value?.ativo ?? 1,
        }
      },
    },

    'formLocal.equipe'() {
      this.validarEquipeNaUbs()
    },

    'formLocal.ubs'(ubsAtual, ubsAnterior) {
      if (ubsAtual === ubsAnterior) {
        return
      }

      if (this.modalMode === 'create') {
        this.formLocal.equipe = null
        this.ineInvalido = false
        this.ubsInvalidaNaEdicao = false
        return
      }

      this.validarEquipeNaUbs()
    },
  },
  methods: {
    /**
     * Abre o modal de adicionar microárea
     */
    abrir() {
      this.$refs.modalAdicionarMicroArea.show()
    },

    /**
     * Fecha o modal de adicionar microárea
     */
    fechar() {
      this.$refs.modalAdicionarMicroArea.hide()
    },

    /**
     * Evento disparado ao esconder o modal
     * Reseta o estado local e emite evento para o componente pai
     */
    onHidden() {
      this.resetEstadoLocal()
      this.$emit('hidden')
    },

    /**
     * Reseta o estado interno do modal
     */
    resetEstadoLocal() {
      this.saving = false
      this.loadingAction = null
      this.modalAlert = {
        show: false,
        variant: 'success',
        message: '',
      }
    },

    /**
     * Exibe mensagem de sucesso no modal
     *
     * @param {string} message
     */
    exibirSucesso(message) {
      this.modalAlert = {
        show: true,
        variant: 'success',
        message,
      }
    },

    /**
     * Exibe mensagem de erro no modal
     *
     * @param {string} message
     */
    exibirErro(message) {
      this.modalAlert = {
        show: true,
        variant: 'danger',
        message,
      }
    },

    /**
     * Valida se a equipe pertence a UBS
     */
    validarEquipeNaUbs() {
      const equipe = this.formLocal?.equipe
      const ubs = this.formLocal?.ubs

      this.ineInvalido = false
      this.ubsInvalidaNaEdicao = false

      if (!equipe || !ubs?.ines_aps) {
        return
      }

      let inesAps = []

      try {
        inesAps = JSON.parse(ubs.ines_aps || '[]')
      } catch (e) {
        inesAps = []
      }

      const existe = inesAps.includes(equipe.ine_esf_eap)

      if (this.modalMode === 'edit') {
        this.ubsInvalidaNaEdicao = !existe
        return
      }

      this.ineInvalido = !existe
    },

    /**
     * Submete o formulário de microárea (criar/editar)
     */
    async onSubmit() {
      const isValid = await this.$refs.form.validate()

      if (!isValid || this.ineInvalido || this.ubsInvalidaNaEdicao) {
        return
      }

      this.saving = true
      this.loadingAction = 'salvar'
      this.modalAlert.show = false

      this.$emit('salvar', {
        form: { ...this.formLocal },
        onSuccess: this.exibirSucesso,
        onError: this.exibirErro,
        onFinally: () => {
          this.saving = false
          this.loadingAction = null
        },
      })
    },

    /**
     * Inativa a microárea após confirmação do usuário
     */
    async onInativar() {
      const confirmado = await this.$bvModal.msgBoxConfirm(
        'Deseja realmente inativar esta microárea?',
        {
          title: 'Confirmar inativação',
          size: 'sm',
          buttonSize: 'sm',
          okTitle: 'Inativar',
          cancelTitle: 'Cancelar',
          okClass: 'btn-inativar-custom',
          cancelClass: 'btn-cancelar-custom',
          modalClass: 'modal-confirmacao-inativacao',
          footerClass: 'p-2 justify-content-end',
          centered: true,
        }
      )

      if (!confirmado) {
        return
      }

      this.saving = true
      this.loadingAction = 'inativar'
      this.modalAlert.show = false

      this.$emit('inativar', {
        form: { ...this.formLocal, ativo: 0 },
        onSuccess: this.exibirSucesso,
        onError: this.exibirErro,
        onFinally: () => {
          this.saving = false
          this.loadingAction = null
        },
      })
    },

    /**
     * Reativa a microárea após confirmação do usuário
     */
    async onReativar() {
      const confirmado = await this.$bvModal.msgBoxConfirm(
        'Deseja realmente reativar esta microárea?',
        {
          title: 'Confirmar reativação',
          size: 'sm',
          buttonSize: 'sm',
          okTitle: 'Reativar',
          cancelTitle: 'Cancelar',
          modalClass: 'modal-confirmacao-reativacao',
          footerClass: 'p-2 justify-content-end',
          centered: true,
        }
      )

      if (!confirmado) {
        return
      }

      this.saving = true
      this.loadingAction = 'reativar'
      this.modalAlert.show = false

      this.$emit('reativar', {
        form: { ...this.formLocal, ativo: 1 },
        onSuccess: this.exibirSucesso,
        onError: this.exibirErro,
        onFinally: () => {
          this.saving = false
          this.loadingAction = null
        },
      })
    },
  },
}
</script>

<style lang="scss">
#administracao-microareas {
  .app-tabela {
    .acoes-container {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .btn {
      border: none;
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .btn-acoes-dropdown {
      width: 34px;
      height: 34px;
      border-radius: 8px;
      background-color: #f3f4f6;
      color: #6b7280;

      &:hover {
        background-color: #e5e7eb;
      }

      i {
        font-size: 16px;
      }
    }

    .menu-lista-acoes {
      padding: 6px 0;
    }
  }
}

.menu-acoes-microarea {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);

  .v-list-item {
    min-height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    &:hover {
      background-color: #f8fafc;
    }
  }

  .v-list-item__title {
    font-size: 13px;
  }

  .v-list-item__icon {
    min-width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icofont-pencil,
  .icofont-ui-user {
    font-size: 14px;
  }
}

#modal-adicionar-microarea {
  .btn-inativar {
    background-color: #fdecea;
    color: #b02a37;
    border: 1px solid #f5c2c7;

    &:hover {
      background-color: #f8d7da;
      color: #842029;
    }

    &:active {
      background-color: #f1b0b7;
    }
  }

  .btn-cancelar {
    background-color: #fff;
    color: #000;
  }

  .btn-reativar {
    background-color: #e6f4ea;
    color: #1e7e34;
    border: 1px solid #b7e4c7;

    &:hover {
      background-color: #d4edda;
      color: #155724;
    }

    &:active {
      background-color: #c3e6cb;
    }
  }
}

.modal-confirmacao-inativacao {
  .modal-footer {
    .btn.btn-secondary {
      background: #ffffff !important;
      color: #495057 !important;
      border: 1px solid #ced4da !important;
      box-shadow: none !important;

      &:hover,
      &:focus,
      &:active {
        background: #f8f9fa !important;
        color: #212529 !important;
        border-color: #adb5bd !important;
        box-shadow: none !important;
      }
    }

    .btn.btn-primary {
      background: #fdecea !important;
      color: #b02a37 !important;
      border: 1px solid #f5c2c7 !important;
      box-shadow: none !important;

      &:hover,
      &:focus,
      &:active {
        background: #f8d7da !important;
        color: #842029 !important;
        border-color: #f1b0b7 !important;
        box-shadow: none !important;
      }
    }
  }
}

.modal-confirmacao-reativacao {
  .modal-footer {
    .btn.btn-secondary {
      background: #ffffff !important;
      color: #495057 !important;
      border: 1px solid #ced4da !important;
      box-shadow: none !important;

      &:hover,
      &:focus,
      &:active {
        background: #f8f9fa !important;
        color: #212529 !important;
        border-color: #adb5bd !important;
        box-shadow: none !important;
      }
    }

    .btn.btn-primary {
      background: #e6f4ea !important;
      color: #1e7e34 !important;
      border: 1px solid #b7e4c7 !important;
      box-shadow: none !important;

      &:hover,
      &:focus,
      &:active {
        background: #d4edda !important;
        color: #155724 !important;
        border-color: #95d5b2 !important;
        box-shadow: none !important;
      }
    }
  }
}
</style>
